import { FAIcon, Tag, TagStyle, Theme } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';

type IProductBO = {
  [key: string]: DynamicObjectInterface;
};

const getUserListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'loginId',
    text: translation('admin.userSetup.loginId'),
    sortable: true,
    width: 7,
    render: (object: IProductBO) => <span>{object.loginId}</span>,
  },
  {
    key: 'name',
    text: translation('admin.userSetup.name'),
    sortable: true,
    width: 9,
    render: (object: IProductBO) => <span>{object.name}</span>,
  },
  {
    key: 'gender',
    text: translation('admin.userSetup.gender'),
    sortable: true,
    width: 6,
    render: (object: IProductBO) => <span>{object.gender}</span>,
  },
  {
    key: 'email',
    text: translation('admin.userSetup.email'),
    sortable: true,
    width: 12,
    render: (object: IProductBO) => <span>{object.email}</span>,
  },
  {
    key: 'phone',
    text: translation('admin.userSetup.phone'),
    sortable: true,
    width: 9,
    render: (object: IProductBO) => <span>{object.phone}</span>,
  },
  {
    key: 'frameworkRole',
    text: translation('admin.userSetup.frameworkRole'),
    sortable: true,
    width: 6,
    render: (object: IProductBO) => <span>{object.frameworkRole}</span>,
  },
  {
    key: 'lastLogin',
    text: translation('admin.userSetup.lastLogin'),
    sortable: true,
    width: 9,
    render: (object: IProductBO) => <span>{object.lastLogin}</span>,
  },
  {
    key: 'status',
    text: translation('admin.userSetup.status'),
    sortable: true,
    width: 5,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },

  {
    key: 'actions',
    width: 1,
    text: translation('admin.userSetup.actions'),
    render: (object: IProductBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.userId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onClick(object.userId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export default getUserListConfig;
